import { createPermissionIndexTransformer } from "../transformers/permissionIndexTransformer";

const createPermissionIndex = (data) => {
  const payload = createPermissionIndexTransformer(data);
  return payload;
};

export { createPermissionIndex };
